import moment from 'moment';
import { formatToCode } from '@/utils/moment-date-utils';

const weekend = ['sábado', 'domingo'];

const addDaysToDate = (date, dias) => {
  const momentDate = moment(date);
  momentDate.add(dias, 'days');
  while (weekend.includes(momentDate.format('dddd').toLowerCase())) {
    momentDate.add(1, 'days');
  }
  return momentDate;
};

export const isSameDate = (date1, date2) => moment(date1).isSame(moment(date2), 'D');

export const isAfterDate = (date1, date2) => moment(date1).isAfter(moment(date2), 'D');

export const isDateAfterOrSameToday = (date) => {
  const hoje = new Date();
  return isSameDate(date, hoje) || isAfterDate(date, hoje);
};

/**
 * Verifica se uma data é válida em relação a uma data mínima permitida.
 *
 * @param {Date} data - A data que será validada.
 * @param {Date | null | undefined} dataMinimaValida - A data mínima aceitável.
 * @returns {boolean} Retorna `true` se a data for válida, ou `false` caso contrário.
 */
export const checkMenorDataValida = (data, dataMinimaValida) => {
  if (!dataMinimaValida) {
    return true;
  }
  return isSameDate(data, dataMinimaValida) || isAfterDate(data, dataMinimaValida);
};

export const getValidDate = (date, defaultDate) => {
  if (!defaultDate) {
    return isDateAfterOrSameToday(date) ? date : formatToCode(moment());
  }
  return isDateAfterOrSameToday(date) ? date : defaultDate;
};

export default {
  addDaysToDate,
  isSameDate,
  isAfterDate,
  isDateAfterOrSameToday,
  checkMenorDataValida,
};
